import { DBFindOne, DBRemove, DBUpdateOne } from '@weblite/persist'
import {
  SharedMediaCategoryType,
  SharedMediaData,
} from '$logic/shared-media/types'

const COLLECTION = 'sharedMedia'
export const sharedMediaStorage = {
  replace(mediaInfo: SharedMediaData) {
    return DBUpdateOne(
      COLLECTION,
      [mediaInfo.roomId, mediaInfo.category],
      { $set: mediaInfo },
      true,
    )
  },

  append(
    roomId: string,
    category: SharedMediaCategoryType,
    iids: number[],
    lastFetchIid: number,
  ): Promise<void> {
    return DBUpdateOne(COLLECTION, [roomId, category], {
      $set: { iids, lastFetchIid },
    })
  },

  prepend(
    roomId: string,
    category: SharedMediaCategoryType,
    iids: number[],
    hasSeenFirst: boolean,
  ): Promise<void> {
    return DBUpdateOne(COLLECTION, [roomId, category], {
      $set: { iids, hasSeenFirst },
    })
    // prepend Iids to last of a category for a roomId
  },

  update(keyRange: any, updateData: Partial<SharedMediaData>) {
    return DBUpdateOne(COLLECTION, keyRange, { $set: updateData })
  },

  clear(roomId: string) {
    return DBRemove(COLLECTION, IDBKeyRange.bound([roomId, 'A'], [roomId, 'Z'])) // TODO: Refactor with  IDBKeyRange.lowerBound([roomId, 'A'])
  },

  clearByCategory(roomId: string, category: SharedMediaCategoryType) {
    return DBRemove(COLLECTION, [roomId, category])
  },

  get(
    roomId: string,
    category: SharedMediaCategoryType,
  ): Promise<SharedMediaData> {
    return DBFindOne(COLLECTION, [roomId, category])
  },
}
